import { render } from "./MultiSelectDropdown.vue?vue&type=template&id=61ffd646&ts=true"
import script from "./MultiSelectDropdown.vue?vue&type=script&lang=ts"
export * from "./MultiSelectDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__